import Immutable from 'seamless-immutable';
import * as actionTypes from './actionTypes';

const initialState = Immutable({
  params: {},
  byId: {},
  actionsloading: false,
});

export function courseTasksReducer(state = initialState, action) {
  // console.log('in dashboard reduecer....', action)
  switch (action.type) {
    case actionTypes.GET_TASKS:
      return {
        ...state,
        byId: {},
        actionsloading: true,
      };
    case actionTypes.GET_TASKS_SUCCESS:
      return {
        ...state,
        byId: action.payload.byId || {},
        actionsloading: false,
      };
    default:
      return state;
  }
}
